


























































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { SuketSehatJiwaInterface } from "@/types/suket_sehat_jiwa";
import { getAge, formatDMYDate } from "@/utility/DateUtils";
import SuketSehatJiwa from "@/services/SuketSehatJiwa";
import StoreSuketSehatJiwa from "@/store/modules/SuketSehatJiwa";

@Component({
  components: {
    CardModalTtd
  },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardInputSKJiwa extends Vue {
  @Prop() readonly register!: string;
  @Prop() dataSkJiwa!: SuketSehatJiwaInterface;

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  register_id = this.dataSkJiwa?.register_id || this.register;
  pasien_rm = this.dataSkJiwa?.pasien_rm || this.statePasien.rm;
  nama = this.dataSkJiwa?.nama || this.statePasien.nama;
  umur =
    this.dataSkJiwa?.umur ||
    getAge(formatDMYDate(this.statePasien.tgl_lahir))
      .toString()
      .concat(" Th");
  pekerjaan = this.statePasien.pekerjaan;
  alamat = this.dataSkJiwa?.alamat || this.statePasien.alamat;
  keterangan = this.dataSkJiwa?.keterangan || "1";
  tujuan = this.dataSkJiwa?.tujuan || "";
  note = this.dataSkJiwa?.note || "";
  unit_id = this.dataSkJiwa?.unit_id || this.user.unit_id;
  dokter_id = this.dataSkJiwa?.dokter_id || this.user.id;

  validasi = [v => !!v || "*Kolom ini harus diisi"];
  modalTtdSkJiwa = false;
  saving = false;

  valPemeriksaanNormal = false;
  showInputTujuan = true;
  labelPemeriksaanNormal =
    "Pada saat pemeriksaan tidak ditemukan gejala gangguan jiwa/penyakit mental dan nilai wood worth dalam batas normal.";

  get statePasien() {
    return storePasien.identitasPasien;
  }

  get user() {
    return userModule.user;
  }

  get input() {
    return {
      register_id: this.register,
      unit_id: this.unit_id,
      dokter_id: this.dokter_id,
      pasien_rm: this.pasien_rm,
      nama: this.nama,
      umur: this.umur,
      pekerjaan: this.pekerjaan,
      alamat: this.alamat,
      keterangan: this.keterangan,
      tujuan: this.tujuan,
      note: this.note
    };
  }

  @Watch("valPemeriksaanNormal")
  changedValPemeriksaanNormal(val) {
    if (val) {
      this.note = this.note
        .concat("\r\n", this.labelPemeriksaanNormal, "\r\n")
        .trimStart();
    } else {
      const search = new RegExp(this.labelPemeriksaanNormal, "g");
      this.note = this.note.replace(search, "").trim();
    }
  }

  mounted() {
    const search = new RegExp(this.labelPemeriksaanNormal, "g");

    this.valPemeriksaanNormal = this.note.search(search) > 0;
    // console.log(this.note.search(search) > 0);

    // setTimeout(() => {
    //   this.valPemeriksaanNormal = true;
    //   console.log("val checkbox should be true");
    //   console.log(this.valPemeriksaanNormal);
    // }, 1000);
  }

  passTtd(value) {
    this.$emit("passTtd", value);
  }

  save() {
    if (this.readOnly) return;
    if (!this.saving) {
      this.saving = true;

      const action = this.dataSkJiwa
        ? SuketSehatJiwa.update(this.dataSkJiwa.id, this.input)
        : SuketSehatJiwa.create(this.input);

      action
        .then(() => {
          this.$emit("showSignatureModal");

          appModule.NoticeDelay("Berhasil Simpan Surat Keterangan Mata");

          this.close();
          StoreSuketSehatJiwa.getSuketByRegister(this.register);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  close() {
    this.$emit("close");
  }
}
